import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import useDashboard from './useDashboard';

const EngagementMetrics = () => {
    const { state } = useContext(SmartContext);
    const { getEngagementMetrics } = useDashboard();

    useEffect(() => {
        getEngagementMetrics();
    }, []);

    if (isEmpty(state?.data?.dashboardData?.engagementMetrics))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="row g-3">
                        <div className="col-auto">
                            <div className="icon-holder mt-1"><i className="icon-listed-search ratio-32 blue-color-filter "></i></div>
                        </div>
                        <div className="col">                                                                                
                            <h3 className="font-24 font-700 mb-0">{state?.data?.dashboardData?.engagementMetrics?.avgViewsPerJob || 0}</h3>
                            <p className="font-16 font-400 mb-0">Avg Views Per Job</p>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12">
                    <hr className="m-0" />
                </div>
                <div className="col-sm-12">
                    <div className="row g-3">
                        <div className="col-auto">
                            <div className="icon-holder"><i className="bi bi-hand-thumbs-up font-32 text-dark-blue "></i></div> 
                        </div>
                        <div className="col">                                                                                
                            <h3 className="font-24 font-700 mb-0">{state?.data?.dashboardData?.engagementMetrics?.interestRate || 0}%</h3>
                            <p className="font-16 font-400 mb-0">Interest Rate</p>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12">
                    <hr className="m-0" />
                </div>
                <div className="col-sm-12">
                    <div className="row g-3">
                        <div className="col-auto">
                            <div className="icon-holder"><i className="bi bi-clipboard-check font-32 text-dark-blue"></i></div>
                        </div>
                        <div className="col">                                                                                
                            <h3 className="font-24 font-700 mb-0">{state?.data?.dashboardData?.engagementMetrics?.applicationRate || 0}%</h3>
                            <p className="font-16 font-400 mb-0">Application Rate</p>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default EngagementMetrics;
